import { useState } from "react";
import emailjs from 'emailjs-com';
import "../styles/comingSoon.css";
import { em } from "framer-motion/client";

export default function ComingSoon() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [query, setQuery] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleNameChange = (e) => setName(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleQueryChange = (e) => setQuery(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Send query data to contact@clientdriven.co.in
      const templateParams = {
        name: name,
        email: email,
        query: query,
      };

      // Try to send using EmailJS
      const response = await emailjs.send(
        'service_dg0967q',
        'template_vrwuz4d',
        templateParams,
        'ablHTDnqGdYqVvnAz'
      );

      await emailjs.send(
        'service_dg0967q',
        'template_q2iby8h',
        {
          name: name,
          email: email,
          query: query
        },
        'ablHTDnqGdYqVvnAz'
      );

      // EmailJS returns text "OK" for success
      if (response.text === 'OK') {
        setMessage('Thank you! Your query has been sent successfully.');
        setName('');
        setEmail('');
        setQuery('');
      } else {
        setMessage('Thank you! Your query has been received. We will contact you soon.');
      }
    } catch (error) {
      console.error('EmailJS Error:', error);
      setName('');
      setEmail('');
      setQuery('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="cds-container">
      <div className="glow-top"></div>
      <div className="glow-bottom"></div>
      <div className="glow-left"></div>

      <nav className="navbar">
        <div className="logo">CDS<span>.</span></div>
        <div className="status-indicator">
          <span className="dot"></span> System Status: Development
        </div>
      </nav>

      <main className="content">
        <div className="badge">COMING SOON</div>
        <h1 className="hero-title">
          Something <span className="gradient-text">new</span> is <br />
          under construction.
        </h1>
        <p className="description">
          We are refining our digital presence to better serve the community.
          The new CDS platform features a revamped architecture and a
          pioneering design language.
        </p>

        <div className="form-container">
          <form onSubmit={handleSubmit} className="cds-form">
            <div className="form-row">
              <div className="form-group">
                <input
                  id="cds-name"
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={handleNameChange}
                  required
                  className="cds-input"
                  autoComplete="name"
                />
              </div>
              <div className="form-group">
                <input
                  id="cds-email"
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  className="cds-input"
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group">
              <textarea
                id="cds-query"
                placeholder="Type your query or message here"
                value={query}
                onChange={handleQueryChange}
                required
                rows={4}
                className="cds-textarea"
              />
            </div>

            <button type="submit" className="primary-btn" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Query'}
            </button>
          </form>
          {message && <p className="notification-message">{message}</p>}
        </div>

        <div className="progress-bar-container">
          <div className="progress-text">
            <span>Project Evolution</span>
            <span>85%</span>
          </div>
          <div className="progress-track">
            <div className="progress-fill"></div>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} CDS Website. All rights reserved.</p>
        <div className="social-links">
          <a href="https://www.linkedin.com/company/clientdriven-solution/" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
        </div>
      </footer>
    </div>
  );
}
